"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var PinItComponent = /** @class */ (function () {
    function PinItComponent() {
        this.url = location.href;
        this.media = '';
        this.description = '';
        // load pinterest sdk if required
        var url = 'https://assets.pinterest.com/js/pinit.js';
        if (!document.querySelector("script[src='" + url + "']")) {
            var script = document.createElement('script');
            script.src = url;
            script['data-pin-build'] = 'parsePins';
            document.body.appendChild(script);
        }
    }
    PinItComponent.prototype.ngAfterViewInit = function () {
        // render pin it button
        window['parsePins'] && window['parsePins']();
    };
    __decorate([
        core_1.Input()
    ], PinItComponent.prototype, "url", void 0);
    __decorate([
        core_1.Input()
    ], PinItComponent.prototype, "media", void 0);
    __decorate([
        core_1.Input()
    ], PinItComponent.prototype, "description", void 0);
    PinItComponent = __decorate([
        core_1.Component({
            selector: 'pin-it',
            template: "<a href=\"//www.pinterest.com/pin/create/button/?url={{url}}&media={{media}}&description={{description}}\" data-pin-do=\"buttonPin\" data-pin-config=\"beside\"></a>"
        })
    ], PinItComponent);
    return PinItComponent;
}());
exports.PinItComponent = PinItComponent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/jw-angular-social-buttons/lib/pin-it.component.js
// module id = ./node_modules/jw-angular-social-buttons/lib/pin-it.component.js
// module chunks = frontend.module